import { SignIn } from '@clerk/clerk-react';
import Container from '@mui/material/Container';
import { useNavigate } from 'react-router-dom';
import { PageURL } from 'router/pageURL';
import { AppFooter } from '../../components/AppFooter/AppFooter';
import { NewSignupPageSectionEnum } from '../SignupPage/enums';
import { useEffect } from 'react';
import { config } from 'utils/config';
import { useAuth } from 'providers';

export const LoginPageProd = () => {
  const { currentSignUpStep, isLoaded, isSignedIn } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (isSignedIn && isLoaded) {
      setTimeout(() => {
        if (currentSignUpStep === NewSignupPageSectionEnum.COMPLETED) {
          navigate(PageURL.ROOT);
        } else {
          const section = currentSignUpStep ?? NewSignupPageSectionEnum.POST_SIGN_UP_PAGE;
          navigate(`${PageURL.SIGNUP}?section=${section}`);
        }
      }, 200);
    }
  }, [currentSignUpStep, isLoaded, isSignedIn]);

  return isLoaded && !isSignedIn ? (
    <div className='min-h-screen grid grid-rows-[1fr_auto]'>
      <main>
        <Container component='div' className={`flex h-full flex-col justify-center`}>
          <div className={`flex justify-center`}>
            <div className='flex flex-col items-center gap-4'>
              <SignIn />
            </div>
          </div>
        </Container>
      </main>
      <AppFooter />
    </div>
  ) : (
    <></>
  );
};

export const LoginPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (config.isLocalAuth) {
      navigate(PageURL.APPLICATIONS);
    }
  }, [navigate]);

  if (config.isLocalAuth) {
    return (
      <div className='flex flex-col items-center justify-center p-8 text-gray-600'>
        <p>Local dev: you are signed in. Set VITE_USE_LOCAL_AUTH=false to use Clerk login.</p>
      </div>
    );
  }

  return <LoginPageProd />;
};
